import { Badge, Box, Typography } from "@mui/material"
import React from "react"
import { TooltipSeeker } from "@ui-seeker/core"
import { legacyColors } from "@palette"

const ellipsisStyle = () => ({
	cursor: "pointer",
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	display: "flex",
	verticalAlign: "middle"
})

export default function AnalyzerTableShowDataHeaderCell({ dataToShow, dataName, propsContainer = {}, color }) {
	const { sx: propsSx = {}, ...restProps } = propsContainer

	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: "center",
			justifyContent: color ? "flex-start" : "center",
			borderBottom: `1px solid ${legacyColors.borderFaint}`,
			width: 1 / 13,
			...propsSx
		}} {...restProps}>
			<Typography variant="subtitle2" sx={{ display: "inline", fontSize: 12, mr: 0.5 }}>
				{dataName}
			</Typography>

			<Box sx={{
				...ellipsisStyle(),
				mr: !!color && 1.5,
				display: "flex",
				alignItems: "center",
				justifyContent: color ? "flex-start" : "center"
			}}>
				{!!color && <ShowColorBadge color={color}/>}
				<ShowDataTypography dataToShow={dataToShow} color={color}/>
			</Box>
		</Box>
	)
}

const ShowDataTypography = ({ dataToShow, color }) => <TooltipSeeker title={color ? dataToShow : ''}>
	<Typography
		variant="body2"
		sx={{
			display: "inline",
			fontSize: 12
		}}
	>
		{dataToShow}
	</Typography>
</TooltipSeeker>


const ShowColorBadge = ({ color }) => (
	<Box sx={{ mx: 1.25 }}>
		<Badge
			badgeContent=""
			sx={{
				"span": {
					minWidth: '10px',
					height: '10px'
				},
				"& .MuiBadge-badge": {
					backgroundColor: color
				}
			}}
		/>
	</Box>
)
